"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "BEM", {
  enumerable: true,
  get: function () {
    return _bem.default;
  }
});
_Object$defineProperty(exports, "classNameFromObject", {
  enumerable: true,
  get: function () {
    return _dedupe.default;
  }
});
exports.closestElement = closestElement;
exports.empty = empty;
exports.fragFromHtml = fragFromHtml;
exports.getMaxZIndex = getMaxZIndex;
exports.getStylesFromElement = getStylesFromElement;
exports.getStylesFromString = getStylesFromString;
exports.hasVerticalScrollbar = hasVerticalScrollbar;
exports.isElementInViewport = isElementInViewport;
exports.mergeElementStyles = mergeElementStyles;
exports.mergeStyleStrings = mergeStyleStrings;
exports.remove = remove;
exports.sanitize = sanitize;
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/assign"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _kebabCase2 = _interopRequireDefault(require("lodash/kebabCase"));
var _dedupe = _interopRequireDefault(require("classnames/dedupe"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _bem = _interopRequireDefault(require("./bem"));
/**
 * Add defaults to the given `DOMPurify.Config` object
 *
 * @param {DOMPurify.Config} opts Options for `DOMPurify`
 * @returns {DOMPurify.Config} The `DOMPurify.Config` object with defaults added
 */
const _createDOMPurifyConfig = ({
  ADD_ATTR = [],
  ADD_TAGS = [],
  FORBID_ATTR = [],
  FORBID_TAGS = [],
  ...opts
}) => ({
  ...opts,
  ADD_ATTR: [...ADD_ATTR],
  ADD_TAGS: [...ADD_TAGS, 'ba-dropdown', 'ba-file-icon', 'ba-icon', 'ba-option-group', 'ba-option', 'ba-select', 'ba-toggle-content'],
  FORBID_ATTR: [...FORBID_ATTR
  // 'style', // needs additional research
  ],
  FORBID_TAGS: [...FORBID_TAGS
  // 'style', // needs additional research
  ],
  SAFE_FOR_JQUERY: true
});

/**
 * Removes unsafe HTML from a string
 *
 * @param {string} html The unsafe HTML string
 * @param {DOMPurify.Config} [opts] Options for `DOMPurify`
 * @returns The safe HTML
 */
function sanitize(html, opts = {}) {
  return _dompurify.default.sanitize(html, _createDOMPurifyConfig(opts));
}

/**
 * Takes a string of HTML and returns a `DocumentFragment`
 * which uses the HTML to create the inner dom of the fragment
 *
 * @param {string} html The unsafe HTML string
 * @param {DOMPurify.Config} [opts] Options for `DOMPurify`
 * @returns {DocumentFragment} The safe HTML as a `DocumentFragment`
 */
function fragFromHtml(html, opts = {}) {
  return sanitize(html, {
    ...opts,
    RETURN_DOM_FRAGMENT: true
  });
}

/**
 * (c) Michael Zelensky 2015
 *
 * DESCRIPTION
 *
 * Returns maximum z-index on page for all elements
 *
 * LICENSE
 *
 * Distributed under MIT License
 * You can use this code in your project without limitation, no matter if it is commercial or not,
 * with all copyright marks intact
 *
 * USAGE
 *
 * var maxZIndex = getMaxZIndex();
 *
 */
function getMaxZIndex() {
  let zIndex;
  let z = 0;
  const all = document.getElementsByTagName('*');
  for (let i = 0, n = all.length; i < n; i++) {
    zIndex = document.defaultView.getComputedStyle(all[i], null).getPropertyValue('z-index');
    zIndex = (0, _parseInt2.default)(zIndex, 10);

    // We will ignore crazy high z-indexes (ie: 2147483640)
    if (zIndex < 90000) {
      z = zIndex ? Math.max(z, zIndex) : z;
    }
  }
  return z;
}

/**
 * Parses style rules from a string into an object
 * @param  {string} styleString String containing style rules
 * @return {object}             Object containing style rules
 */
function getStylesFromString(styleString) {
  const element = document.createElement('div');
  element.style.cssText = styleString;
  return getStylesFromElement(element);
}

/**
 * Returns an object representing the style that has been explicitly
 * defined on this element.
 * @param  {object} element The element retrieve styles from
 * @return {object}         Object containing styles
 */
function getStylesFromElement(element) {
  const obj = {};
  for (let i = 0; i < element.style.length; i++) {
    const itemKey = element.style.item(i);
    obj[itemKey] = element.style[itemKey];
  }
  return obj;
}

/**
 * Returns true if the element has a scrollbar and false if it does not
 * @param {object} element
 */
function hasVerticalScrollbar(element) {
  return element.offsetWidth - element.clientWidth > 0;
}

/**
 * Merges style strings together. Last takes precedence.
 * @param  {...string} styleStrings Style string to merge
 * @return {string}                 Merged style string
 */
function mergeStyleStrings(...styleStrings) {
  var _context;
  const mergedStyles = (0, _reduce.default)(styleStrings).call(styleStrings, (memo, styleString) => (0, _assign.default)(memo, getStylesFromString(styleString)), {});
  return (0, _map.default)(_context = (0, _keys.default)(mergedStyles)).call(_context, key => `${key}: ${mergedStyles[key]}`).join(';');
}
window.getStylesFromString = getStylesFromString;
window.mergeStyleStrings = mergeStyleStrings;

/**
 * Applies new styles to an element without removing all existing styles.
 * Replaces existing styles with new styles defined in the style argument.
 * @param  {object} element The element to style
 * @param  {object} styles  Style object
 */
function mergeElementStyles(element, styles) {
  var _context2;
  const cssText = [];
  const combinedStyles = (0, _assign.default)({}, getStylesFromElement(element), styles);
  (0, _reduce.default)(_context2 = (0, _keys.default)(combinedStyles)).call(_context2, (memo, key) => {
    memo.push(`${(0, _kebabCase2.default)(key)}: ${combinedStyles[key]}`);
    return memo;
  }, cssText);
  element.style.cssText = cssText.join('; ');
  return element;
}

/**
 * Converts an object of key/value pairs into a string to be used as a className
 * value. The keys are the individual class names, and the values are used as booleans
 * to determine whether the given class name key is in the return string or not.
 * @param obj
 * @returns string
 */

/**
 * Determines if any portion of an element is in the viewport (even if by only 1px)
 *
 * @param el element The element to test
 * @returns {boolean}
 */
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.bottom > 0 && rect.right > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight;
}

/**
 * Removes all children from an element node
 * @param  {object} element The parent node
 */
function empty(element) {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

/**
 * Removes a node from its parent if the parent exists
 * @param  {object} node The DOM node to remove
 */
function remove(node) {
  if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

/**
 * Returns a function to find the closest element that matches the given selection.
 * This is useful for array functions like filter() and some().
 * @param  {string} selector CSS selector to match
 * @return {function}        Function to call with a DOM node
 */
function closestElement(selector) {
  return function (node) {
    do {
      if (node.nodeType === 1 && node.matches(selector)) {
        return node;
      }
      node = node.parentNode;
    } while (node);
  };
}